import { OrbitComponent } from "../base-components/orbit-component/orbit-component";
import { VerticalGamesListBox } from "./boxes/vertical-games-list.box";
import { HeaderBox } from "./boxes/header.box";
import React from "react";
import { GamesListBox } from "./boxes/games-list.box";
import { VerticalGamesListGameComponent } from "./vertical-games-list-game.component";
import { HeaderTitleBox } from "./boxes/header-title.box";
import { HeaderCloseButtonBox } from "./boxes/header-close.box";
import { observer } from "mobx-react";
import { JackpotWidgetComponent, JACKPOT_WIDGET_LAYOUT } from "../jackpot-widget/jackpot-widget.component";
import { DjWidgetBox } from "./boxes/dj-widget.box";
import { IDrawer } from "../../services/drawer/drawer.service.interface";
import { GameInfo } from "../../services/games/game-info";
import { JackpotWidgetConfiguration } from "../../services/configurations/config-data-sections/jackpot-widget.configuration";
import { observable, action, makeObservable } from "mobx";
import { CyClass } from "../../../common/cy-classes";
import { JackpotType } from "../../services/jackpots/jackpot.constants";

export interface VerticalGamesListComponentProps {
    gamesInfo: GameInfo[];
    drawer: IDrawer;
    seoCategory: string;
    listTitle: string;
    widgetConf?: JackpotWidgetConfiguration;
}

@observer
export class VerticalGamesListComponent extends OrbitComponent<VerticalGamesListComponentProps> {
    @observable.ref
    private _shouldMinimizeJackpotWidget: boolean = false;

    constructor(props: VerticalGamesListComponentProps) {
        super(props);

        makeObservable(this);
    }

    private _closeDrawer() {
        this.props.drawer.closeDrawer();
    }

    private _renderHeader() {
        return (
            <HeaderBox>
                <HeaderCloseButtonBox className={CyClass("cy-vertical-games-list-close-btn")}
                                      onClick={() => this._closeDrawer()}/>
                <HeaderTitleBox>{this.services.translation.translate(this.props.listTitle)}</HeaderTitleBox>
            </HeaderBox>
        );
    }

    private _renderGamesList() {

        if (!this.props.gamesInfo.length) {
            return null;
        }

        return (
            <GamesListBox>
                {this.props.gamesInfo.map((gameInfo, index) => this._renderOneGame(gameInfo, index))}
            </GamesListBox>
        );
    }

    private _onGameOpen = () => {
        this.props.drawer.closeDrawer();
    }

    private _renderOneGame(gameInfo: GameInfo, index: number) {
        return (
            <VerticalGamesListGameComponent key={gameInfo.gameType}
                                            gameInfo={gameInfo}
                                            onGameOpen={this._onGameOpen}
                                            seoCategory={this.props.seoCategory}
                                            listTitle={this.props.listTitle}
                                            gameIndex={index}
                                            displayJackpotInfo={this.props.widgetConf ? !this.props.widgetConf.display : true}
            />
        );
    }

    private _shouldMinimizeWidget() {
        const isMobileLandscape = this.services.mediaQuery.mAndBelow && this.services.mediaQuery.landscape;
        return this._shouldMinimizeJackpotWidget || isMobileLandscape;
    }

    private _onJackpotWidgetClicked = async () => {
        (await this.services.drawer).right.closeDrawer();
    }

    private _renderJackpotWidget() {
        if (!this.props.widgetConf?.display) {
            return null;
        }

        return (
            <JackpotWidgetComponent
                WrapperBox={DjWidgetBox}
                widgetConfig={this.props.widgetConf}
                layout={this._shouldMinimizeWidget ? JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE : JACKPOT_WIDGET_LAYOUT.LANDSCAPE}
                seoCategory="Game_Drawer"
                onClick={this.props.widgetConf?.jackpotType === JackpotType.Party ? this._onJackpotWidgetClicked : undefined}
            />
        );
    }

    @action.bound
    private _onScroll(e) {
        if (e.target && e.target.scrollTop > 0 && !this._shouldMinimizeJackpotWidget) {
            this._shouldMinimizeJackpotWidget = true;
        }
    }

    render() {
        return (
            <VerticalGamesListBox onScroll={(e) => this._onScroll(e)} className={CyClass('cy-vertical-games-list')}>
                {this._renderHeader()}
                {this._renderJackpotWidget()}
                {this._renderGamesList()}
            </VerticalGamesListBox>
        );
    }
}